import Image from 'next/image';
import NextButton from '@/components/Button/NextButton';
import OfferLabel from '../OfferLabel/OfferLabel';
import { RepopulationOffer, RepopulationSubTypes } from '@/types/offerWall';
import styles from './SecondaryInfoModal.module.scss';
import SafeHTMLContent from '../DangerousHtml/DangerousHtml';

interface Props {
  isRecommend?: boolean;
  offerCardData?: RepopulationOffer;
}

const SecondaryInfoModal = ({ isRecommend = false, offerCardData }: Props) => {
  if (!offerCardData) return null;
  return (
    <div className={`${styles.wrapper} ${isRecommend ? styles.recommend : ''}`}>
      <Image
        src={offerCardData.partnerImageUrl}
        alt={`${offerCardData.partnerName} logo`}
        className={styles.logo}
        width={186}
        height={42}
        priority
      />
      <div className={styles.line} />
      <p className={styles.title}>{offerCardData.name}</p>
      <div className={styles.line} />
      <SafeHTMLContent
        html={
          offerCardData.disclaimer
            ? offerCardData.disclaimer
            : offerCardData.desc
        }
        styles={styles.descWrapper}
      />
      <div className={styles.line} />
      <div className={styles.buttonsWrapper}>
        <NextButton
          target="_blank"
          text="Continue"
          link={offerCardData.url}
          styles={styles.button}
          isArrow
        />
        <OfferLabel
          text={RepopulationSubTypes[offerCardData.productSubType]}
          plusIcon
        />
      </div>
    </div>
  );
};

export default SecondaryInfoModal;
